"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _input = _interopRequireDefault(require("../inputs/input"));

var _button = _interopRequireDefault(require("../buttons/button"));

var _checkbox = _interopRequireDefault(require("../checkbox/checkbox"));

var _social = require("./social");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _templateObject19() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-top: 0.5rem;\n  color: #ffc900;\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteralLoose(["\n  color: rgb(103, 179, 213);\n  margin-left: 0.3rem;\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 1.3rem;\n  color: #272829;\n  line-height: 2.2rem;\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 50%;\n  max-width: 13rem;\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteralLoose(["\n      font-size: 1.6rem;\n    "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteralLoose(["\n  color: #272829;\n  text-decoration: none;\n  font-size: 1.3rem;\n  ", ";\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n  font-weight: 300;\n  font-size: 1.8rem;\n  color: #272829;\n  line-height: 1.3;\n  max-width: 90%;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 1rem;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n  display: none;\n  @media screen and (max-width: 768px) {\n    display: inline;\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline;\n  @media screen and (max-width: 768px) {\n    display: none;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n      height: 0;\n      @media screen and (max-width: 768px) {\n        height: 4rem;\n      }\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 1.5rem;\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n      align-items: center;\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  @media screen and (max-width: 768px) {\n    flex-direction: column;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  margin: 0 auto;\n  max-width: 120rem;\n  padding: 4rem;\n  @media screen and (max-width: 768px) {\n    padding: 3rem;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: #fff;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var Main = _styledComponents["default"].div(_templateObject());

var FooterContainer = _styledComponents["default"].div(_templateObject2());

var FooterContent = _styledComponents["default"].div(_templateObject3());

var FlexRow = _styledComponents["default"].div(_templateObject4(), function (props) {
  return props.centered && (0, _styledComponents.css)(_templateObject5());
});

var FlexColumn = _styledComponents["default"].div(_templateObject6());

var HorizontalSpacer = _styledComponents["default"].div(_templateObject7(), function (props) {
  return props.mobileView && (0, _styledComponents.css)(_templateObject8());
});

var DesktopView = _styledComponents["default"].div(_templateObject9());

var MobileView = _styledComponents["default"].div(_templateObject10());

var VerticalSpacer = _styledComponents["default"].div(_templateObject11());

var FooterCell = _styledComponents["default"].div(_templateObject12());

0;

var FooterCellTitle = _styledComponents["default"].div(_templateObject13());

var FooterLink = _styledComponents["default"].a(_templateObject14(), function (props) {
  return props.main && (0, _styledComponents.css)(_templateObject15());
});

var FooterLinkContainer = _styledComponents["default"].div(_templateObject16());

var FooterCopyright = _styledComponents["default"].div(_templateObject17());

var Link = _styledComponents["default"].a(_templateObject18());

var ErrorMessage = _styledComponents["default"].div(_templateObject19());

var Footer = function Footer(props) {
  var baseUrl = props.baseUrl,
      profileUrl = props.profileUrl,
      loading = props.loading,
      onClickEvent = props.onClickEvent;

  var _useState = (0, _react.useState)(""),
      email = _useState[0],
      setEmail = _useState[1];

  var _useState2 = (0, _react.useState)(true),
      checked = _useState2[0],
      setChecked = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      error = _useState3[0],
      setError = _useState3[1];

  var _useState4 = (0, _react.useState)(false),
      privacyError = _useState4[0],
      setPrivacyError = _useState4[1];

  var handleSubmit = function handleSubmit() {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    setPrivacyError(false);

    if (!checked) {
      setPrivacyError(true);
    }

    if (!email) {
      setError("This field is required");
      return;
    } else if (!re.test(String(email).toLowerCase())) {
      setError("Invalid email");
      return;
    }

    if (!checked || !email) {
      return;
    }

    if (onClickEvent) {
      onClickEvent(email);
    }

    setEmail("");
    setChecked(false);
  };

  var handleChange = function handleChange(event) {
    var value = event.target.value;
    setEmail(value);
    setError("");
  };

  var handleChangeChecbox = function handleChangeChecbox() {
    setChecked(!checked);

    if (privacyError) {
      setPrivacyError(false);
    }
  };

  return /*#__PURE__*/_react["default"].createElement(Main, null, /*#__PURE__*/_react["default"].createElement(FooterContainer, null, /*#__PURE__*/_react["default"].createElement(FlexRow, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(FooterLink, {
    main: true,
    href: baseUrl + "/static/aboutUs"
  }, "About Us")), /*#__PURE__*/_react["default"].createElement(VerticalSpacer, {
    style: {
      width: "4rem"
    }
  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(FooterLink, {
    main: true,
    href: baseUrl + "/stores"
  }, "Branches")), /*#__PURE__*/_react["default"].createElement(VerticalSpacer, {
    style: {
      width: "4rem"
    }
  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(FooterLink, {
    main: true,
    href: baseUrl + "/static/contactus"
  }, "Contact Us"))), /*#__PURE__*/_react["default"].createElement(HorizontalSpacer, {
    style: {
      height: "4rem"
    }
  }), /*#__PURE__*/_react["default"].createElement(FooterContent, null, /*#__PURE__*/_react["default"].createElement(FooterCell, null, /*#__PURE__*/_react["default"].createElement(FlexRow, null, /*#__PURE__*/_react["default"].createElement(FooterLinkContainer, null, /*#__PURE__*/_react["default"].createElement(FlexColumn, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(FooterLink, {
    href: "https://smadvantage.com/"
  }, "SM Advantage")), /*#__PURE__*/_react["default"].createElement(HorizontalSpacer, null), /*#__PURE__*/_react["default"].createElement(HorizontalSpacer, null), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(FooterLink, {
    href: baseUrl + "/static/returnAndExchangePolicy"
  }, "Returns & Exchange")))), /*#__PURE__*/_react["default"].createElement(FooterLinkContainer, null, /*#__PURE__*/_react["default"].createElement(FlexColumn, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(FooterLink, {
    href: profileUrl + "/orders"
  }, "Track Order")))))), /*#__PURE__*/_react["default"].createElement(HorizontalSpacer, {
    mobileView: true
  }), /*#__PURE__*/_react["default"].createElement(FooterCell, null, /*#__PURE__*/_react["default"].createElement(FlexColumn, null, /*#__PURE__*/_react["default"].createElement(FooterCellTitle, null, "Join our newsletter and exclusive updates", /*#__PURE__*/_react["default"].createElement(DesktopView, null, /*#__PURE__*/_react["default"].createElement("br", null)), /*#__PURE__*/_react["default"].createElement(MobileView, null, " "), "enjoy 20% on your first order."), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: "-0.5rem"
    }
  }, /*#__PURE__*/_react["default"].createElement(_input["default"], {
    style: {
      background: "#fff",
      width: "100%",
      maxWidth: "40rem",
      borderRadius: "0",
      border: "none",
      borderBottom: "1px solid #E0E1E2",
      paddingLeft: "0"
    },
    placeholder: "Your email address",
    noRightComponentBorder: true,
    value: email,
    onChange: handleChange,
    error: error,
    rightComponent: /*#__PURE__*/_react["default"].createElement(_button["default"], {
      style: {
        color: "#BB1F25",
        fontSize: "1.5rem",
        borderRadius: "0",
        width: "12rem",
        marginLeft: "-0.35rem",
        height: "4.5rem",
        border: "none",
        borderBottom: "1px solid #E0E1E2"
      },
      clickAnimation: "highlight",
      disabled: loading,
      onClick: handleSubmit
    }, loading ? "Sending..." : "SIGN ME UP"),
    rightComponentProps: {
      width: "auto"
    }
  })), /*#__PURE__*/_react["default"].createElement(HorizontalSpacer, null), /*#__PURE__*/_react["default"].createElement(FlexRow, null, /*#__PURE__*/_react["default"].createElement(_social.Facebook, null), /*#__PURE__*/_react["default"].createElement(VerticalSpacer, {
    style: {
      width: "0.5rem"
    }
  }), /*#__PURE__*/_react["default"].createElement(_social.Instagram, null))))), /*#__PURE__*/_react["default"].createElement(HorizontalSpacer, {
    style: {
      height: "2rem"
    },
    mobileView: true
  }), /*#__PURE__*/_react["default"].createElement(FlexRow, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(FooterLink, {
    href: baseUrl + "/static/privacy"
  }, "Privacy Policy")), /*#__PURE__*/_react["default"].createElement(VerticalSpacer, null), "|", /*#__PURE__*/_react["default"].createElement(VerticalSpacer, null), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(FooterLink, {
    href: baseUrl + "/static/termsAndCondition"
  }, "Terms and Conditions"))), /*#__PURE__*/_react["default"].createElement(HorizontalSpacer, {
    style: {
      height: "0.5rem"
    }
  }), /*#__PURE__*/_react["default"].createElement(FooterCopyright, null, "\xA9 2020. Ace Hardware Philippines. All Rights Reserved.")));
};

var _default = Footer;
exports["default"] = _default;
module.exports = exports["default"];